const TickIcon = () => (
  <svg width="15" height="15" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.1876 0.8125C14.2609 0.8125 18.3752 4.92682 18.3752 10.0001C18.3752 15.0734 14.2609 19.1877
       9.1876 19.1877C4.11432 19.1877 0 15.0734 0 10.0001C0 4.92682 4.11432 0.8125 9.1876 0.8125ZM7.27968
        12.9843L5.03033 10.7331C4.64712 10.3497 4.64704 9.72437 5.03033 9.34101C5.4137 8.95772 6.04176
         8.96012 6.42234 9.34101L8.00812 10.928L11.953 6.98315C12.3364 6.59978 12.9617 6.59978 13.345
          6.98315C13.7284 7.36644 13.7278 7.99233 13.345 8.37516L8.703 13.0172C8.32018 13.4 7.69428
           13.4005 7.31099 13.0172C7.30022 13.0064 7.28983 12.9955 7.27968 12.9843Z"
      fill="#00BA00"
    />
  </svg>
);

export default TickIcon;
